import { DiagnosisSidePanelContentDataAccessor } from './DiagnosisSidePanelContentDataAccessor';
import { DiagnosisSidePanelList } from './DiagnosisSidePanelList';
import { DiagnosisSidePanelListLoader } from './DiagnosisSidePanelList.loader';

type DiagnosisSidePanelContentProps = {
   readonly patientId: number;
};

export const DiagnosisSidePanelContent = (props: DiagnosisSidePanelContentProps): JSX.Element => {
   return (
      <DiagnosisSidePanelListLoader patientId={props.patientId}>
         {({ diagnosis }) => (
            <>
               <DiagnosisSidePanelList diagnosis={diagnosis} patientId={props.patientId} />
               <DiagnosisSidePanelContentDataAccessor diagnosis={diagnosis} />
            </>
         )}
      </DiagnosisSidePanelListLoader>
   );
};
